<template>
  <div class="mb">
    <div class="mbbanner"></div>
    <van-tabs
      :ellipsis="false"
      swipeable
      v-model="activeName"
      @change="tabchange"
    >
      <van-tab v-for="(i, j) in tabslist" :title="i.name" :key="j">
        <div class="jj" v-if="activeName == 0"><mintro /></div>
        <!-- <div class="jj" v-if="activeName == 1"><msurveyframeworkVue /></div> -->
        <div class="jj" v-if="activeName == 1"><msurveylayout /></div>
        <div class="jj" v-if="activeName == 2"><msurveyqualifyVue /></div>
        <div class="jj" v-if="activeName == 3"><msurveyhonorVue /></div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import msurveyframeworkVue from "./msurveyframework.vue";
import msurveyhonorVue from "./msurveyhonor.vue";
import mintro from "./msurveyintro.vue";
import msurveyqualifyVue from "./msurveyqualify.vue";
import msurveylayout from "./msurveylayout.vue";
export default {
  components: {
    mintro,
    msurveylayout,
    msurveyframeworkVue,
    msurveyqualifyVue,
    msurveyhonorVue,
  },
  data() {
    return {
      tabslist: [
        { name: "企业简介" },
        { name: "市场布局" },
        { name: "企业资质" },
        { name: "企业荣誉" },
      ],
      activeName: 0,
    };
  },
  methods: {
    tabchange(e) {
      this.activeName = e;
    },
  },
};
</script>

<style lang="less" scoped>
.mb {
  .jj {
    padding: 4vw;
    background: rgba(244, 246, 249, 0.5);
  }
  .mbbanner {
    width: 100%;
    height: 42.67vw;
    background: url("../../assets/image/mbbanner.png") no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
  }
  width: 100%;
}
::v-deep .van-tab--active {
  color: #1961ac !important;
  font-size: 4vw;
  // font-size: 4vw;
}
::v-deep .van-tabs__line {
  // width: 100%;
  background-color: #1668bc !important;
}
::v-deep .van-tabs__line {
  width: 60px;
  height: 2px;
  border-radius: 4px 4px 0 0;
  background: #1668bc;
  opacity: 1;
  color: #1668bc;
}
</style>
